import { WeekStartsOn } from './components/fields/WeekStartsOn'

export function PersonalizationForm() {
  return <WeekStartsOn />
}
